import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, allowExpired = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-blue-500" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Bloqueia qualquer usuário não-admin cujo perfil ou plano não esteja ativo.
  const isBlocked =
    !["admin", "super_admin"].includes(user.role) &&
    (user.status !== "approved" ||
      user.plan_state === "expired" ||
      user.plan_state === "pending_trial");

  if (isBlocked && !allowExpired && location.pathname !== "/planos") {
    return <Navigate to="/planos" replace />;
  }
  return children;
}
